/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const carouselCustomProviderSX =
	(slides: number, withoutmargin: boolean): SxProps<Theme> =>
	(theme) => ({
		position: 'relative',
		py: 0,
		height: 'auto',
		maxWidth: '100%',
		[theme.breakpoints.down(410)]: {
			'.carousel__slider.carousel__slider--horizontal': {
				height: 'inherit',
				'> .carousel__slider-tray-wrapper.carousel__slider-tray-wrap--horizontal': {
					height: 'inherit',
					'> .carousel__slider-tray.carousel__slider-tray--horizontal': {
						height: 'inherit',
						'> .carousel__slide': {
							height: 'inherit',
						},
					},
				},
			},
		},

		'.carousel__dot--selected': {
			backgroundColor: '#FFF !important',
			opacity: '1 !important',
		},

		'.carousel__dot--0': {
			borderRadius: '3px 0 0 3px',
		},

		'.carousel__dot-group button:last-child': {
			borderRadius: '0 3px 3px 0',
		},

		'.carousel__dot': {
			backgroundColor: '#FFF',
			border: 'none',
			opacity: '0.5',
			width: `calc(300px/${slides})`,
			height: '6px',
		},

		[theme.breakpoints.down('sm')]: {
			'.carousel__dot': {
				width: `calc(150px/${slides})`,
			},
		},

		'.carousel__back-button, .carousel__next-button': {
			position: 'absolute',
			top: '50%',
			transform: 'translateY(-50%)',
			height: (theme) => theme.spacing(5),
			width: (theme) => theme.spacing(5),
			borderRadius: '50%',
			background: 'none',
			border: '1px solid transparent',

			'&:hover': {
				cursor: 'pointer',
				color: 'primary.main',
				borderColor: 'primary.light',
			},
		},

		'.carousel__back-button': {
			left: 0,
		},

		'.carousel__next-button': {
			right: 0,
		},

		div: {
			outline: 'none',
		},
		marginBottom: withoutmargin ? '' : { xs: '20px', sm: '40px' },
	});
